// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__Client from "./Client.js";
import * as Buhta_landing__ClientMobile from "./ClientMobile.js";
import * as Buhta_landing__ClientsCard from "./ClientsCard.js";
import * as Buhta_landing__ClientsCardMobile from "./ClientsCardMobile.js";
import * as Buhta_landing__ClientsCarousel from "./ClientsCarousel.js";
import * as Buhta_landing__ClientsConclusions from "./ClientsConclusions.js";
import * as Buhta_landing__ClientsConclusionsMobile from "./ClientsConclusionsMobile.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function Clients(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const intl = ReactIntl.useIntl();
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const homePage = match[0].homePage;
  const clients_0 = {
    quote: homePage.client_quote_2,
    name: homePage.client_name_2,
    logo: "/static/images/crystal.png",
    image: "bg-catering",
    imageMobile: "bg-catering-mobile",
    background: "bg-brown"
  };
  const clients_1 = {
    hd: {
      quote: homePage.client_quote_1,
      name: homePage.client_name_1,
      logo: "/static/icons/davai-shodim.svg",
      image: "bg-ds",
      imageMobile: "bg-ds-mobile",
      background: "bg-loft"
    },
    tl: /* [] */ 0
  };
  const clients = {
    hd: clients_0,
    tl: clients_1
  };
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h1", {
            children: homePage.client_title,
            className: "h4 lg:h3 text-center text-black-landing"
          }),
          JsxRuntime.jsx("p", {
            children: homePage.client_subtitle,
            className: "paragraph-large text-black-landing text-center mt-2"
          }),
          deviceType === "mobile" || deviceType === "tablet" ? JsxRuntime.jsx(Buhta_landing__ClientMobile.make, {
              clients: clients
            }) : JsxRuntime.jsx(Buhta_landing__Client.make, {
              clients: clients
            }),
          JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
            classes: {
              hd: "flex m-auto mt-8 lg:mt-16",
              tl: /* [] */ 0
            },
            label: Buhta_landing__I18n.trans(intl, "start_using"),
            onClick: (function (param) {
              Buhta_landing__EventHandlers.scrollToFooter(deviceType);
            })
          }),
          JsxRuntime.jsx("p", {
            children: homePage.business_count,
            className: "paragraph-small text-center text-gray-landing mt-4"
          })
        ],
        className: "py-10 lg:py-30 px-6 sm:px-48"
      }),
      deviceType === "mobile" || deviceType === "tablet" ? JsxRuntime.jsx(Buhta_landing__ClientsCardMobile.make, {}) : JsxRuntime.jsx(Buhta_landing__ClientsCard.make, {}),
      JsxRuntime.jsx(Buhta_landing__ClientsCarousel.make, {}),
      deviceType === "mobile" || deviceType === "tablet" ? JsxRuntime.jsx(Buhta_landing__ClientsConclusionsMobile.make, {}) : JsxRuntime.jsx(Buhta_landing__ClientsConclusions.make, {})
    ]
  });
}

const make = Clients;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
